import React from 'react';
import { Card, Col, Row, Statistic } from 'antd';
import { ColProps } from 'antd/lib/col';
// Styles
import styles from './KpiCard.module.scss';

export type Kpi = {
  title: string;
  value: string | number;
  suffix?: string;
  caption?: React.ReactNode;
};

type KpiCardProps = {
  items: Kpi[];
  /** The width of each figure at each breakpoint. */
  colProps: ColProps;
  loading?: boolean;
};

const KpiCard = ({ items, colProps, loading }: KpiCardProps): JSX.Element => (
  <Card className={styles.card}>
    <Row gutter={[16, 16]}>
      {items.map(({ title, value, suffix, caption }) => (
        <Col key={title} {...colProps}>
          <Statistic
            title={title}
            value={value}
            suffix={suffix}
            loading={loading}
          />
          {caption && <span className={styles.caption}>{caption}</span>}
        </Col>
      ))}
    </Row>
  </Card>
);

export default KpiCard;
